import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueGtag from "vue-gtag";

Vue.config.productionTip = false

if(window.location.host.includes("www.")){
  window.location = window.location.href.replace("www.", "")
}

Vue.use(VueGtag, {
  config: { 
    id: "G-7VW2B2TZPM", 
    anonymize_ip: true, 
    allow_google_signals: false,
    allow_ad_personalization_signals: false 
  },
  appName: 'Selfie',
  pageTrackerScreenviewEnabled: true
}, router);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')